// import { baseUrl } from '@src/helpers/urlHelper';
import { Editor } from '@tinymce/tinymce-react';
import React, { useRef } from 'react';
import { tinyeditorCofig } from './tinyconfig';

const TinymceEditor = (props) => {
  const editorRef = useRef(null);

  const handlePassValue = (val) => {
    props.editorValue(val);
  };

  return (
    <Editor
      apiKey="6y9naihudklqv7xgeiuevg0ru537vmpz495xl5qsdfj81rav"
      onInit={(evt, editor) => (editorRef.current = editor)}
      // value={props.value}
      initialValue={props.value}
      onEditorChange={(value) => {
        props.editorValue(value, props.id);
      }}
      init={tinyeditorCofig}
    />
  );
};

export default TinymceEditor;
